import { DsPinInterface } from '../interfaces/ds-pin.interface';

export class DsPinUpdateDto {
  /**
   * The description of the pin.
   */
  description?: string;

  /**
   * The pin's rating.
   */
  rating?: number;

  /**
   * The pin's state.
   */
  state?: number;

  /**
   * The pin's due date.
   */
  dueDate?: number;

  /**
   * The pin's company id.
   */
  companyId?: number;

  /**
   * The pin's campaign id.
   */
  campaignId?: number;

  /**
   * The pin's position id.
   */
  positionId?: number;

  /**
   * The pin's emitter id.
   */
  emitter?: string;

  /**
   * Creates an instance of DsPinUpdateDto.
   *
   * @param dsPinUpdateDto the ds pin update dto
   */
  constructor(dsPinUpdateDto: DsPinInterface) {
    this.description = dsPinUpdateDto.description;
    this.rating = dsPinUpdateDto.rating;
    this.state = dsPinUpdateDto.state;
    this.dueDate = dsPinUpdateDto.dueDate;
    this.companyId = dsPinUpdateDto.companyId;
    this.campaignId = dsPinUpdateDto.campaignId;
    this.positionId = dsPinUpdateDto.positionId;
    this.emitter = dsPinUpdateDto.emitter;
  }
}
